module.exports = __webpack_public_path__ + "static/media/Banner-Flugblatt2.fd0f4ed6.png";